import { Heading, useColorModeValue } from "@chakra-ui/react";

const Label = (props) => {
  const color = useColorModeValue("gray.500", "gray.400");

  return (
    <Heading
      as="h6"
      textTransform="uppercase"
      fontSize="sm"
      fontWeight={700}
      letterSpacing={1}
      color={color}
      {...props}
    />
  );
};

export default Label;
